document.addEventListener('DOMContentLoaded', () => {
  const base = window.Shopify?.routes?.root || '/';
  document.querySelectorAll('[data-engraving]').forEach(panel => {
    const form = panel.closest('form');
    const toggle = panel.querySelector('[data-engraving-toggle]');
    const fields = panel.querySelector('[data-engraving-fields]');
    const rows = [...panel.querySelectorAll('[data-engraving-blade]')];
    const error = panel.querySelector('[data-engraving-error]');
    const express = form.querySelector('.dynamic-checkout');
    let busy = false;
    let uncertain = false;
    const chosen = () => rows.filter(row => toggle.checked && (!row.querySelector('[data-engraving-blade-toggle]') || row.querySelector('[data-engraving-blade-toggle]').checked));
    const update = () => {
      fields.hidden = !toggle.checked;
      if (express) express.hidden = toggle.checked;
      rows.forEach(row => {
        const check = row.querySelector('[data-engraving-blade-toggle]');
        const input = row.querySelector('[data-engraving-text]');
        if (check) check.disabled = !toggle.checked;
        input.disabled = !toggle.checked || Boolean(check && !check.checked);
        input.required = !input.disabled;
      });
      toggle.setCustomValidity(toggle.checked && chosen().length === 0 ? 'Select at least one knife to engrave.' : '');
      error.hidden = true;
    };
    toggle.disabled = false;
    toggle.addEventListener('change', update);
    rows.forEach(row => {
      row.querySelector('[data-engraving-blade-toggle]')?.addEventListener('change', update);
      row.querySelector('[data-engraving-text]').addEventListener('input', event => event.target.setCustomValidity(''));
    });
    update();
    form.addEventListener('submit', async event => {
      if (!toggle.checked) return;
      event.preventDefault();
      if (busy || uncertain || !form.reportValidity()) return;
      const selected = chosen();
      if (!selected.length) return;
      const properties = {Engraving: 'Free'};
      for (const row of selected) {
        const input = row.querySelector('[data-engraving-text]');
        input.value = input.value.trim();
        input.setCustomValidity(!input.value ? 'Enter your engraving text.' : input.value.length > input.maxLength ? 'Please shorten your engraving text.' : '');
        if (!input.reportValidity()) return;
        properties['Engraving — ' + input.dataset.bladeLabel] = input.value;
      }
      busy = true;
      const buttons = [...form.querySelectorAll('button[type=submit]'), ...document.querySelectorAll('button[type=submit][form="' + form.id + '"]')];
      buttons.forEach(button => button.disabled = true);
      try {
        const data = new FormData(form);
        const response = await fetch(base + 'cart/add.js', {method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items:[{id:Number(data.get('id')),quantity:Math.max(1,Number(data.get('quantity')) || 1),properties}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this item. Please try again.');
        window.location.assign(base + 'cart');
      } catch (failure) {
        error.hidden = false;
        error.textContent = failure.message;
        if (failure instanceof TypeError || failure instanceof SyntaxError) {
          uncertain = true;
          error.textContent = 'Please check your shopping bag before adding again.';
          const link = document.createElement('a'); link.href = base + 'cart'; link.textContent = ' View shopping bag'; error.append(link);
        } else buttons.forEach(button => button.disabled = false);
        busy = false;
      }
    });
  });
});
